if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.querySelector('[name=size]').disabled = false;
        if (this.form.querySelector("[name='properties[raw_private_sale_discounted_price]']")) {
          this.form.querySelector("[name='properties[raw_private_sale_discounted_price]']").disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const productSize = formData.get('size');
        // Stop the add to cart flow if the product size has not been selected
        if (!productSize) {
          this.handleErrorMessage(this.dataset.sizeErrorMessage);
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((error) => error)
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || document.querySelector('#ErrorModal');
        if (!this.errorMessageWrapper) return;
        this.errorMessageContainer = this.errorMessageContainer || this.errorMessageWrapper.querySelector('#Product-Error-Message');

        if (errorMessage) {
          this.errorMessageWrapper.show();
          this.errorMessageContainer.textContent = errorMessage;
        }
      }
    },
  );
}

class VariantSelector extends HTMLElement {
  constructor() {
    super();
  }

  renderProductElements(selectedOptionUrl) {
    this.toggleLoadingOverlay();
    const urlToFecth = `${selectedOptionUrl}?section_id=${this.dataset.sectionId}`;

    fetch(urlToFecth)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        let elementsToUpdateSources = Array.from(html.querySelectorAll('[data-updatable-element]'));
        let elementsToUpdate = Array.from(document.querySelectorAll('[data-updatable-element]'));

        elementsToUpdateSources = this.filterElements(elementsToUpdateSources);
        elementsToUpdate = this.filterElements(elementsToUpdate);

        elementsToUpdate.forEach((element, index) => {
          if (element.innerHTML !== elementsToUpdateSources[index].innerHTML) {
            element.innerHTML = elementsToUpdateSources[index].innerHTML;
          }
        });
      })
      .catch((error) => error)
      .finally(() => {
        this.finalSteps(selectedOptionUrl);
      });
  }

  filterElements(elements) {
    return elements;
  }

  disableAddButton() {
    const addButton = document.querySelector('.product__buy-button');
    if (!addButton) return;

    addButton.setAttribute('disabled', true);
  }

  finalSteps(selectedOptionUrl) {
    this.updateURL(selectedOptionUrl);
    this.toggleLoadingOverlay();
  }

  toggleLoadingOverlay() {
    const overlay = document.querySelector('.loading-overlay');
    if (!overlay) return;

    overlay.classList.toggle('hidden');
  }

  updateURL(url) {
    window.history.replaceState({}, '', url);
  }
}

if (!customElements.get('product-size-selector')) {
  class ProductSizeSelector extends VariantSelector {
    constructor() {
      super();

      this.sizeSelector = this.querySelector('#size-selector');
      this.sizeSelectorPrevValue = this.sizeSelector.value;
      this.requestSizeModal = document.getElementById('RequestSizeModal');
    }

    connectedCallback() {
      this.sizeSelector.addEventListener('change', this.handleSizeChange.bind(this));
    }

    handleSizeChange(event) {
      event.preventDefault();

      this.disableAddButton();

      if (event.target.value === 'request-size-option-value') {
        this.requestSizeModal.show();
        this.sizeSelector.value = this.sizeSelectorPrevValue;
      } else {
        this.renderProductElements(event.target.value);
      }
    }

    filterElements(elements) {
      return elements.filter((element) => !element.classList.contains('product__media-gallery-wrapper'));
    }
  }

  customElements.define('product-size-selector', ProductSizeSelector);
}

if (!customElements.get('product-color-selector')) {
  class ProductColorSelector extends VariantSelector {
    constructor() {
      super();

      this.colorSelector = this.querySelector('#color-selector');
    }

    connectedCallback() {
      this.colorSelector.addEventListener('change', this.handleColorChange.bind(this));
    }

    handleColorChange(event) {
      event.preventDefault();

      this.disableAddButton();
      this.renderProductElements(event.target.value);
    }

    finalSteps(selectedOptionUrl) {
      this.refreshCarousel();

      this.updateURL(selectedOptionUrl);
      this.toggleLoadingOverlay();
    }

    refreshCarousel() {
      const event = new CustomEvent('refresh-carousel', {
        bubbles: true,
        composed: true,
      });
      document.dispatchEvent(event);
    }
  }

  customElements.define('product-color-selector', ProductColorSelector);
}

if (!customElements.get('product-lightbox-opener')) {
  customElements.define(
    'product-lightbox-opener',
    class ProductLightboxOpener extends HTMLElement {
      constructor() {
        super();

        this.targetSlideId = this.getAttribute('data-target-slide');
        this.lightboxContainer = document.getElementById('ProductLightboxContainer');
        this.lightbox = this.lightboxContainer.querySelector('ud-lightbox');
      }

      connectedCallback() {
        this.addEventListener('click', () => {
          this.lightbox.setActiveSlide(this.targetSlideId, { smoothScrool: false });
          this.lightboxContainer.show(this);
        });
      }
    },
  );
}
